/**
 * Dynamic FAQ section – optional behavior.
 * Accordion expand/collapse is handled by theme.js (accordion-details).
 * Add section-specific logic here (e.g. hash-link scrolling to #faq-...) if needed.
 */
(function () {
  'use strict';
  // Stub: no-op for now; theme's accordion-details handles details/summary behavior.
})();
